var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIHiContrast02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 170,
    viewBox: "0 0 84 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.41797,
    width: 80,
    height: 166.667,
    rx: 12.5,
    fill: "#F4F6FA",
    stroke: "#D2D6DC",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 2.25,
    width: 77.5,
    height: 164.167,
    rx: 11.25,
    fill: "#F4F6FA",
    stroke: "#10141A",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.168,
    y: 6,
    width: 21.6667,
    height: 6.66667,
    rx: 3.33333,
    fill: "#10141A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9951 80.0469H21.3545V82.0859H25.3447V83.1934H21.3545V85.3906C22.5439 85.3848 23.5312 85.3525 24.3164 85.2939C25.1016 85.2354 25.8955 85.127 26.6982 84.9688L26.8389 86.1113C25.9834 86.2754 25.1426 86.3838 24.3164 86.4365C23.4902 86.4893 22.3916 86.5156 21.0205 86.5156H20.0361V78.9219H25.9951V80.0469ZM32.5693 93.4238H31.2158V89.3457H21.9697V88.2031H32.5693V93.4238ZM32.5693 87.4648H31.251V77.8145H32.5693V87.4648ZM29.5283 87.3594H28.1924V83.0703H26.083V81.9102H28.1924V78.1484H29.5283V87.3594ZM42.6416 80.0996C42.6416 80.9492 42.9258 81.7725 43.4941 82.5693C44.0684 83.3604 44.8037 84.0342 45.7002 84.5908C46.5967 85.1416 47.5049 85.502 48.4248 85.6719L47.792 86.832C46.9951 86.6445 46.21 86.3398 45.4365 85.918C44.6631 85.4961 43.9688 84.9746 43.3535 84.3535C42.7383 83.7324 42.2666 83.0498 41.9385 82.3057C41.6104 83.0439 41.1387 83.7236 40.5234 84.3447C39.9082 84.9658 39.2139 85.4902 38.4404 85.918C37.6729 86.3398 36.8877 86.6445 36.085 86.832L35.4521 85.6719C36.3721 85.4902 37.2773 85.127 38.168 84.582C39.0586 84.0312 39.7852 83.3604 40.3477 82.5693C40.916 81.7783 41.2002 80.9551 41.2002 80.0996V78.9043H42.6416V80.0996ZM49.1631 91.2969H34.8545V90.1543H49.1631V91.2969ZM63.0674 87.377H52.2568V79.1504H62.8916V80.3105H53.6631V82.6309H62.5576V83.7383H53.6631V86.252H63.0674V87.377ZM64.7197 91.3848H50.4111V90.2422H64.7197V91.3848Z",
    fill: "#62666C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIHiContrast02);
export default __webpack_public_path__ + "static/media/i_hi_contrast_02.eae10ae038280290be79fc0c74d813cb.svg";
export { ForwardRef as ReactComponent };